import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService, ROLES } from '../../auth/auth.service';
import { logInfoAction } from 'src/app/shared/util/error-capture.util';

@Injectable({
    providedIn: 'root'
})
export class FormGuardService implements CanActivate {

    constructor(public auth: AuthService, public router: Router) { }
    async canActivate(): Promise<boolean> {
        logInfoAction('Form guard check', { url: this.router.url });
        return true;
    }
}
